import { SyntheticEvent } from 'react';
import noProfileImage from '../../assets/imgs/DefaultPfp.svg';

export const AvatarImage = ({
    src,
    testId,
    wrapperClass,
    isFeatured = false,
    alt = '',
}: {
    src: string | undefined | null
    testId?: string | undefined | null
    wrapperClass?: string | undefined | null
    isFeatured?: boolean
    alt?: string
}) => {
    const isDefaultPhoto = !src || (typeof src === 'string' && src.toLowerCase().includes('defaultpfp'));

    if (isFeatured && isDefaultPhoto) {
        return null;
    }

    const addDefaultSrc = (ev: SyntheticEvent<HTMLImageElement, Event>) => {
        const target = ev.target as HTMLImageElement;
        target.src = noProfileImage;
    };

    return (
        <div className={`w-full h-full bg-neutral-700 relative overflow-hidden rounded-full ${  wrapperClass || ''}`}>
            <img
                data-testid={testId}
                className="w-full h-full object-cover rounded-full"
                src={src ? src : noProfileImage}
                alt={alt}
                onError={addDefaultSrc}
            />
        </div>
    );
};
